import * as taxCalcInput from "./taxCalcInput"

export function 住宅借入金特別控除額計算関数(input: taxCalcInput.全収入情報): number {
    if (!input.住宅情報) return 0;
  
    // 1. ローン残高の上限判定（2024年入居の場合の例）
    let 残高上限 = 0;
    switch (input.住宅情報.住宅区分) {
      case '認定': 残高上限 = 45000000; break;
      case 'ZEH':  残高上限 = 35000000; break;
      case '省エネ': 残高上限 = 30000000; break;
      case '一般':  残高上限 = 0; break;
    }
  
    // 2. 最大控除額の計算（残高の0.7%）
    const 対象残高 = Math.min(input.住宅情報.年末ローン残高, 残高上限);
    const 控除額 = Math.floor(対象残高 * 0.007);
    return 控除額
  }

export function 住宅借入金特別控除使用可否判断関数(input: taxCalcInput.全収入情報, 所得: number): boolean {
    if (!input.住宅情報) return false;
  
    // トータルの返済期間を計算（当初の期間 - 短縮した期間）
    const 短縮年数 = input.住宅情報.期間短縮型の繰り上げ決済を行ったか 
      ? input.住宅情報.期間短縮型の繰り上げ決済を行った場合何年分の期間を短縮したか 
      : 0;
    const トータルの返済期間 = input.住宅情報.何年分のローンを組んだか - 短縮年数;
  
    // すべての条件が「true」であるときだけ true を返す
    return (
      input.住宅情報.住宅借入金を使ったか &&
      input.住宅情報.床面積50平米以上かつ半分以上居住用か &&
      トータルの返済期間 >= 10 && // ★ここでトータル10年以上かを判定
      所得 <= 20000000 // 合計所得2,000万円以下
    );
  }